import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function AdminFundingTab({ selectedInstructor, funding, onApprove, onReject }) {
  return (
    <div data-testid="admin-funding-tab">
      <h2 className="text-xl font-bold text-slate-800 mb-4" style={{ fontFamily: 'Nunito' }}>{selectedInstructor.name}'s Funding Requests</h2>
      <div className="space-y-3">
        {funding.map(f => (
          <Card key={f.request_id} className="rounded-2xl border-slate-100 shadow-sm" data-testid={`funding-${f.request_id}`}>
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <p className="font-semibold text-slate-700">{f.description}</p>
                  <p className="text-xs text-slate-400">{new Date(f.created_at).toLocaleDateString()} {f.child_name ? `for ${f.child_name}` : ''}</p>
                </div>
                <div className="text-right">
                  <p className="text-lg font-extrabold text-[#1E1B4B]">${f.amount.toFixed(2)}</p>
                  <Badge variant="outline" className={`rounded-full ${f.status === 'approved' ? 'border-green-200 text-green-600 bg-green-50' : f.status === 'rejected' ? 'border-red-200 text-red-600 bg-red-50' : f.status === 'completed' ? 'border-blue-200 text-blue-600 bg-blue-50' : 'border-amber-200 text-amber-600 bg-amber-50'}`}>{f.status}</Badge>
                </div>
              </div>
              {f.receipt_filename && <p className="text-xs text-green-600 mb-2">Receipt uploaded</p>}
              {f.status === 'pending' && (
                <div className="flex gap-2 mt-3">
                  <Button size="sm" className="rounded-xl bg-green-500 hover:bg-green-600 text-white font-bold gap-1" onClick={() => onApprove(f.request_id)} data-testid={`approve-funding-${f.request_id}`}><CheckCircle2 className="w-4 h-4" /> Approve</Button>
                  <Button size="sm" variant="outline" className="rounded-xl text-red-500 border-red-200 font-bold gap-1" onClick={() => onReject(f.request_id)} data-testid={`reject-funding-${f.request_id}`}><XCircle className="w-4 h-4" /> Reject</Button>
                </div>
              )}
            </CardContent>
          </Card>
        ))}
        {funding.length === 0 && <p className="text-center text-slate-400 py-8">No funding requests</p>}
      </div>
    </div>
  );
}
